import { render, staticRenderFns } from "./ListItemMessage.vue?vue&type=template&id=05f19c35&"
import script from "./ListItemMessage.vue?vue&type=script&lang=js&"
export * from "./ListItemMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports